export const validateCaseSubjectInfo = (
  saluation: string | number | null,
  firstName: string,
  lastName: string,
  dob: string,
  gender: string | number | null,
  ssnNumber: string,
  employee: string | number | null,
  address: string | number | null,
  contact: string | number | null,
  QMEDoctor: string | number | null
): string[] => {
  const errors: string[] = []; // Array to hold error messages

  const trimmedFirstName = firstName.trim();
  const trimmedLastName = lastName.trim();
  const today = new Date().toISOString().split("T")[0];

  if (saluation === null || saluation === "") {
    errors.push("Salutation is mandatory");
  }
  if (!trimmedFirstName) {
    errors.push("First Name is mandatory");
  }
  if (!trimmedLastName) {
    errors.push("Last Name is mandatory");
  }
  // if (!dob) {
  //   errors.push("Date of Birth is mandatory");
  // } else if (dob > today) {
  //   errors.push("Invalid Date of Birth");
  // }
  if (!gender) {
    errors.push("Gender is mandatory");
  }
  if (ssnNumber) {
    if (ssnNumber.length !== 11) {
      errors.push("SSN Number Format Invalid");
    }
  }
  if (!QMEDoctor) {
    errors.push("Please select QME Doctor");
  }
  if (!employee) {
    errors.push("Please select Employer");
  }

  // if (!address) {
  //   errors.push("Please select Employer Address");
  // }
  // if (!contact) {
  //   errors.push("Please select Employer Contact");
  // }

  // Email validation

  // Phone number validation (only if entered)

  return errors; // Return the array of errors
};

export const validateCaseSubjectAddress = (
  addressType: string | number | null,
  addressDetails: { city: string; state: string; country: string; zip: string },
  addressline1: string | number | null,
  phoneNumber: (string | number)[],
  emailAddress: (string | number)[],
  faxNumber: (string | number)[]
): string[] => {
  const errors: string[] = [];

  if (!addressType) {
    errors.push("Address Type is mandatory");
  }

  // Validate each address field separately
  if (!addressDetails.city.trim()) {
    errors.push("Please select City, State, Country and ZipCode");
  }

  if (!addressline1) {
    errors.push("Address Line #1 is mandatory");
  }

  if (phoneNumber.length === 0) {
    errors.push("At least one valid Phone Number is required");
  } else if (phoneNumber.length > 0) {
    const phoneRegex = /^\d{3}-\d{3}-\d{4}$/;

    const phoneSet = new Set();
    phoneNumber.forEach((num) => {
      const trimmedPhoneNumber = num.toString().trim();

      if (!phoneRegex.test(trimmedPhoneNumber)) {
        errors.push(`Invalid Phone Number: ${trimmedPhoneNumber}`);
      }

      if (phoneSet.has(trimmedPhoneNumber)) {
        errors.push(`Duplicate Phone Number: ${trimmedPhoneNumber}`);
      } else {
        phoneSet.add(trimmedPhoneNumber);
      }
    });
  }

  // Validate Email Address (at least one required)
  if (emailAddress.length > 0) {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const emailSet = new Set();
    emailAddress.forEach((email) => {
      const trimmedEmailAddress = email.toString().trim();

      if (!trimmedEmailAddress) {
        errors.push("Email is mandatory");
      } else if (!emailRegex.test(trimmedEmailAddress)) {
        errors.push(`Invalid Email Address: ${trimmedEmailAddress}`);
      }

      if (emailSet.has(trimmedEmailAddress)) {
        errors.push(`Duplicate Email Address: ${trimmedEmailAddress}`);
      } else {
        emailSet.add(trimmedEmailAddress);
      }
    });
  }

  if (faxNumber.length > 0) {
    const faxRegex = /^\d{3}-\d{3}-\d{4}$/;

    const faxSet = new Set();
    faxNumber.forEach((num) => {
      const trimmedFaxNumber = num.toString().trim();

      if (!faxRegex.test(trimmedFaxNumber)) {
        errors.push(`Invalid Fax Number: ${trimmedFaxNumber}`);
      }

      if (faxSet.has(trimmedFaxNumber)) {
        errors.push(`Duplicate Fax Number: ${trimmedFaxNumber}`);
      } else {
        faxSet.add(trimmedFaxNumber);
      }
    });
  }

  return errors;
};
